import { FC } from 'react'
import { Text, TextProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type BigNumberProps = TextProps & UnistylesVariants<typeof stylesheet>

const BigNumber: FC<BigNumberProps> = ({ children, size = 'normal', style, ...props }) => {
    const { styles } = useStyles(stylesheet, { size })

    return (
        <Text {...props} style={[styles.bigNumber, style]}>
            {children}
        </Text>
    )
}

const stylesheet = createStyleSheet((theme) => ({
    bigNumber: {
        fontFamily: theme.fonts.bold,
        variants: {
            size: {
                normal: {
                    fontSize: 18,
                },
                small: {
                    fontSize: 16,
                },
            },
        },
    },
}))

export default BigNumber
